/**
 * urlパラメータの文字列を配列形式に加工
 * @param {string} param - 分解したいパラメータ
 * @return {array} - [key,value]の形でパラメータを返す
 */
const getParam = (param) => {
  if(String(param).length == 0) return null;

  // ?もしくは&で分解
  let item = param.split(/[?&]/);

  // console.log(item);

  let res = {};

  /**
   * パラメータの数だけ繰り返し
   * =を起点にkeyとvalueの形に変換
   * valueの中に+が存在すればsplit
   */
  for(let i = 0; i < item.length; i++) {
    if(item[i] == '' || item[i] == null) continue;

    let pattern = /(\w+)=(\w+)/;
    let queryParse = item[i].replace(pattern, "$1,$2");
    queryParse = queryParse.split(',');

    // パラメータが複数の場合は値を+でつないでいる
    let mulchQuery = queryParse[1].split('+');
    // console.log(mulchQuery);
    res[queryParse[0]] = mulchQuery;
  }

  return res;
}


export default getParam;